/**
 * PlanIndicator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IndicatorCategoryDto } from './indicator-category';


export interface IndicatorDto { 
    id: string;
    parentId?: string | null;
    name: string;
    dataFabricKey: string;
    calculable?: boolean;
    calculationStrategy?: IndicatorDto.CalculationStrategyEnum;
    group?: string;
    category?: IndicatorCategoryDto;
    showReport?: boolean;
    supportedRelationshipLevels?: Array<string>;
}
export namespace IndicatorDto {
    export const CalculationStrategyEnum = {
        Standard: 'STANDARD',
        Inverse: 'INVERSE'
    } as const;
    export type CalculationStrategyEnum = typeof CalculationStrategyEnum[keyof typeof CalculationStrategyEnum];
}


